export const deepPurpleMui = {
  /**
   * Preview: ![deepPurple 50](https://mui.com/static/colors-preview/deepPurple-50-24x24.png)
   */
  _50: "#ede7f6",
  /**
   * Preview: ![deepPurple 100](https://mui.com/static/colors-preview/deepPurple-100-24x24.png)
   */
  _100: "#d1c4e9",
  /**
   * Preview: ![deepPurple 200](https://mui.com/static/colors-preview/deepPurple-200-24x24.png)
   */
  _200: "#b39ddb",
  /**
   * Preview: ![deepPurple 300](https://mui.com/static/colors-preview/deepPurple-300-24x24.png)
   */
  _300: "#9575cd",
  /**
   * Preview: ![deepPurple 400](https://mui.com/static/colors-preview/deepPurple-400-24x24.png)
   */
  _400: "#7e57c2",
  /**
   * Preview: ![deepPurple 500](https://mui.com/static/colors-preview/deepPurple-500-24x24.png)
   */
  _500: "#673ab7",
  /**
   * Preview: ![deepPurple 600](https://mui.com/static/colors-preview/deepPurple-600-24x24.png)
   */
  _600: "#5e35b1",
  /**
   * Preview: ![deepPurple 700](https://mui.com/static/colors-preview/deepPurple-700-24x24.png)
   */
  _700: "#512da8",
  /**
   * Preview: ![deepPurple 800](https://mui.com/static/colors-preview/deepPurple-800-24x24.png)
   */
  _800: "#4527a0",
  /**
   * Preview: ![deepPurple 900](https://mui.com/static/colors-preview/deepPurple-900-24x24.png)
   */
  _900: "#311b92",
  /**
   * Preview: ![deepPurple A100](https://mui.com/static/colors-preview/deepPurple-A100-24x24.png)
   */
  A100: "#b388ff",
  /**
   * Preview: ![deepPurple A200](https://mui.com/static/colors-preview/deepPurple-A200-24x24.png)
   */
  A200: "#7c4dff",
  /**
   * Preview: ![deepPurple A400](https://mui.com/static/colors-preview/deepPurple-A400-24x24.png)
   */
  A400: "#651fff",
  /**
   * Preview: ![deepPurple A700](https://mui.com/static/colors-preview/deepPurple-A700-24x24.png)
   */
  A700: "#6200ea",
};
